import { render, staticRenderFns } from "./ProductCardPrice.vue?vue&type=template&id=5befe41c&"
import script from "./ProductCardPrice.vue?vue&type=script&lang=js&"
export * from "./ProductCardPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/parker/lets_code/frances-valentine/new-fv-original/FV-original/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5befe41c')) {
      api.createRecord('5befe41c', component.options)
    } else {
      api.reload('5befe41c', component.options)
    }
    module.hot.accept("./ProductCardPrice.vue?vue&type=template&id=5befe41c&", function () {
      api.rerender('5befe41c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/product-card/ProductCardPrice.vue"
export default component.exports